import { useEffect, useState, useRef, useMemo } from "react";
import api from "../services/axiosInstance";
import { useNotification } from '../pages/NotifPopup';
import { convertAndCompressImage } from './CompressImage';
import { Document, Page, pdfjs } from 'react-pdf';
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url
).toString();

export function ShowPic({
  open,
  onClose,
  row,
  backendPort,
  token,
  onUploadSuccess,
  readOnly = false,
  customFileUrl = null,
  customFiles = [],
  customTitle = "Bukti Pembayaran",
  customNote = "",
  zIndex = null,
  fitImageToFrame = false,
}) 
{  
  const imageUrl = customFileUrl || (
    row?.bukti && row.bukti !== ""
      ? `${backendPort}/uploads/nota/${row.bukti}`
      : null
  );
  
  const { showNotif } = useNotification();
  const fileRef = useRef(null);
  const frameRef = useRef(null);
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(imageUrl);
  const [bisaUpload, setBisaUpload] = useState(true);
  const [imgLoading, setImgLoading] = useState(false);
  const [scale, setScale] = useState(1);
  const [fileType, setFileType] = useState(null);
  const [activeFileIndex, setActiveFileIndex] = useState(0);
  const [frameWidth, setFrameWidth] = useState(0);

  const daftarFile = useMemo(() => {
    if (Array.isArray(customFiles) && customFiles.length > 0) {
      return customFiles
        .filter((item) => Boolean(item?.url))
        .map((item, index) => ({
          url: item.url,
          name: item.name || '',
          caption: item.caption || item.name || `Dokumen ${index + 1}`,
          note: item.note || "",
        }));
    }
    if (imageUrl) {
      return [{ url: imageUrl, caption: "Dokumen", note: "" }];
    }
    return [];
  }, [customFiles, imageUrl]);
  const [visibleFiles, setVisibleFiles] = useState([]);

  useEffect(() => {
    setVisibleFiles(daftarFile);
    setActiveFileIndex(0);
  }, [daftarFile, open]);

  const activeFile = visibleFiles[activeFileIndex] || null;
  const activeUrl = activeFile?.url || (visibleFiles.length === 0 ? null : imageUrl);
  const isPdfFile = (
    String(fileType || '').toLowerCase().includes('pdf') ||
    /\.pdf($|\?)/i.test(String(activeUrl || '')) ||
    /\.pdf($|\?)/i.test(String(activeFile?.name || ''))
  );

  //tampilkan imageUrl yang tersimpan
  useEffect(() => {
  let blobUrl;

  if (!activeUrl) {
    setPreview(null);
    return;
  }

  const fetchFile = async () => {
    try {
      setImgLoading(true);

      const res = await api.get(activeUrl, {
        responseType: "blob"
      });

      blobUrl = URL.createObjectURL(res.data);

      setPreview(blobUrl);
      setFileType(res.data.type); // WAJIB
    } catch (err) {
      console.error(err);
      setPreview(null);
    } finally {
      setImgLoading(false);
    }
  };

  fetchFile();

  return () => {
    if (blobUrl) URL.revokeObjectURL(blobUrl);
  };

  }, [activeUrl]);

  useEffect(() => {
  return () => {
    if (preview?.startsWith("blob:")) {
      URL.revokeObjectURL(preview);
    }
  };
  }, [preview]);

  useEffect(() => {
    if (!file) return; 
    
    const gambar = URL.createObjectURL(file);
    setImgLoading(true);
    setPreview(gambar);
    setFileType(file.type); 
  }, [file]);
  
  useEffect(() => {
  if (open) {
    setScale(1);
    setActiveFileIndex(0);
  }
  }, [open]);

  useEffect(() => {
    if (!frameRef.current) return;
    const updateWidth = () => {
      const w = frameRef.current?.clientWidth || 0;
      setFrameWidth(w);
    };
    updateWidth();

    const observer = new ResizeObserver(updateWidth);
    observer.observe(frameRef.current);
    window.addEventListener("resize", updateWidth);
    return () => {
      observer.disconnect();
      window.removeEventListener("resize", updateWidth);
    };
  }, [open]);

  if (!open) return null;
  
  const handleFileChange = async (e) => {
    const f = e.target.files[0];
    if (!f) return;

    const dataFile = await convertAndCompressImage(f)
      .catch(err => {
        console.error('Error convert and kompress file:', err);
        if (f.size > 5 * 1024 * 1024) {
          showNotif('error', 'File melebihi 5MB');
          return null;
        }; // fallback ke file asli jika proses gagal
      });
    
    if(!dataFile) return;  
    setFile(dataFile);
  };

  const handleUpload = async () => {
    if (!file) return;
    if (!row?.id) {
      showNotif("error", "Data upload tidak valid");
      return;
    }

    const formData = new FormData();
    formData.append("bukti", file);
    formData.append("id", row.id);

    try {
      setBisaUpload(false);
      await api.post(
        `${backendPort}/api/main/petty_jurnal_pict`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          }
        }
      );

      showNotif("success","Data berhasil di upload");
      setFile(null);
      setBisaUpload(true);
      handleClear();
      onUploadSuccess(); // refresh data
    } catch (err) {
      console.error(err);
      setBisaUpload(true);
      showNotif("error","Upload data gagal");
    } finally {
    }
  };

  const handleClear = async () => {
    setFile(null);
    setPreview(activeUrl || null);
    if (fileRef.current) fileRef.current.value = "";
  };

  const handleWheel = (e) => {
    if (fitImageToFrame) return;
    e.preventDefault();
    let newScale = scale + (e.deltaY < 0 ? 0.1 : -0.1);
    if (newScale < 1) newScale = 1;
    if (newScale > 5) newScale = 5;
    setScale(newScale);
  };

  return (
    <div
      className="modal-backdrop-custom"
      style={Number.isFinite(Number(zIndex)) ? { zIndex: Number(zIndex) } : undefined}
    >
      <div
        className="modal-content-showPic"
        style={{ width: "70vw", maxWidth: "1500px", height: "92vh", display: "flex", flexDirection: "column" }}
      >
        <div className="d-flex justify-content-between gap-2">
          <h5 className="mt-3 fw-bold fs-5">{customTitle}</h5>
          <div>
            <button
              type="button"
              className="btn btn-sm btn-outline-secondary page16-panel-close"
              onClick={onClose}
              aria-label="Tutup"
            >
              <i className="fa fa-times" aria-hidden="true" />
            </button>
          </div>
        </div>
        <hr/>

        <div className="row flex-grow-1" style={{ minHeight: 0 }}>
          {/* Gambar */}
          <div className="col-md-8 text-center mb-3 d-flex flex-column" style={{ minHeight: 0 }}>
            <div
            ref={frameRef}
            style={{
              width: "100%",
              aspectRatio: "1 / 1",
              maxHeight: "72vh",
              overflow: fitImageToFrame ? "hidden" : "auto",
              border: "1px solid #ddd",
              position: "relative",
              margin: "0 auto"
            }}
            onWheel={handleWheel}
          >{imgLoading && (
              <div
                style={{
                  position: "absolute",
                  inset: 0,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  background: "rgba(0,0,0,0.4)",
                  color: "#fff",
                  fontWeight: "bold",
                  zIndex: 10
                }}
              >
                <div className="loader"></div>
              </div>
            )}
            {(preview) 
            
            ? (isPdfFile) 
              ? (
                  <div style={{ width: `${Math.max(scale * 100, 100)}%` }}>
                    <Document 
                      file={preview} 
                      onLoadSuccess={() => setImgLoading(false)}
                      onLoadError={(err) => {
                        setImgLoading(false);
                        console.error('Gagal render PDF:', err);
                        showNotif('error', 'Gagal menampilkan PDF');
                      }}>
                      <Page pageNumber={1} width={Math.round(frameWidth * Math.max(scale, 1)) || undefined} />
                    </Document>
                  </div>
                ) 
              : ( <img
                    src={preview}
                    alt="Bukti"
                    onLoad={() => setImgLoading(false)}
                    onError={() => setImgLoading(false)}
                    draggable={false}
                    style={{
                      width: fitImageToFrame ? "100%" : `${Math.max(scale * 100, 100)}%`,
                      height: fitImageToFrame ? "100%" : "auto",
                      objectFit: fitImageToFrame ? "contain" : undefined,
                      display: "block",
                      userSelect: "none",
                      cursor: "default",
                      opacity: imgLoading ? 0.3 : 1
                    }}
                  />) 
            : (
              <div className="text-muted d-flex justify-content-center align-items-center h-100">
                Memuat gambar..
              </div>
            )}
          </div>
          
          </div>
          <div className="col-md-4 text-center my-3" style={{ maxHeight: "78vh", overflowY: "auto" }}>
          {/* Catatan */}
            <div>
              <label>Keterangan</label>
              <textarea
                className="form-control col-md-12 "
                value={activeFile?.caption || customNote || activeFile?.note || row?.catatan || ""}
                readOnly
                rows={3}
              />
            </div>
          {readOnly && daftarFile.length > 1 && (
            <div className="form-control mt-3 text-start">
              <label className="fw-bold mb-2">Daftar Dokumen</label>
              <div className="d-flex flex-column gap-2" style={{maxHeight: "230px", overflowY: "auto"}}>
                {visibleFiles.map((item, idx) => (
                  <div
                    key={`${item.url}-${idx}`}
                    className={`d-flex align-items-center justify-content-between px-2 py-1 rounded ${idx === activeFileIndex ? "border border-primary bg-primary bg-opacity-10" : "border border-light-subtle"}`}
                  >
                    <button
                      type="button"
                      className="btn btn-link text-decoration-none text-start p-0 flex-grow-1 d-flex align-items-center gap-2"
                      onClick={() => {
                        setFile(null);
                        setActiveFileIndex(idx);
                      }}
                    >
                      <span
                        className="d-inline-flex justify-content-center align-items-center rounded-circle overflow-hidden border"
                        style={{ width: "50px", height: "50px", minWidth: "50px", background: "#f8fafc" }}
                      >
                        {(/\.pdf($|\?)/i.test(String(item.url || '')) || String(item.name || '').toLowerCase().endsWith('.pdf'))
                          ? <i className="fa fa-file-pdf text-danger"></i>
                          : <img
                              src={item.url}
                              alt={item.caption}
                              loading="lazy"
                              decoding="async"
                              style={{ width: "100%", height: "100%", objectFit: "cover" }}
                            />
                        }
                      </span>
                      <span className="text-dark small text-truncate">{item.caption}</span>
                    </button>
                    {/*<button
                      type="button"
                      className="btn btn-outline-danger btn-sm ms-2"
                      onClick={() => {
                        setVisibleFiles((prev) => {
                          const next = prev.filter((_, i) => i !== idx);
                          if (next.length === 0) {
                            setActiveFileIndex(0);
                            return [];
                          }
                          if (idx < activeFileIndex) {
                            setActiveFileIndex((prevIdx) => Math.max(prevIdx - 1, 0));
                          } else if (idx === activeFileIndex) {
                            setActiveFileIndex(Math.min(activeFileIndex, next.length - 1));
                          }
                          return next;
                        });
                      }}
                      aria-label={`Hapus dokumen ${idx + 1}`}
                    >
                      <i className="fa fa-trash"></i>
                    </button>*/}
                  </div>
                ))}
              </div>
            </div>
          )}
          {!readOnly && (
            <>
              <div className="my-5"></div>
              <div className="my-5"></div>
              <div className="form-control">
              <label className="mt-2 mb-5 fw-bold"> Upload / Ganti Pic</label>
              <input
                className="text-center mb-2"
                ref={fileRef}
                type="file"
                accept="image/*,application/pdf"
                onChange={handleFileChange}
              />
              <div className="row d-flex justify-content-center mt-2 gap-2 px-3">
              <button
                  className="btn btn-secondary col-md-3 text-white"
                  onClick={handleClear}
                >
                  Clear
                </button>
              <button
                  className="btn btn-primary col-md-5"
                  onClick={handleUpload}
                  disabled={!bisaUpload}
                >
                  Upload
                </button>
              </div>  
              </div>
            </>
          )}
          <div className="form-control mt-5">
            <a
              href={activeUrl}
              target="_blank"
              rel="noopener noreferrer"
              aria-disabled={!activeUrl}
              className="btn btn-success col-md-6"
            >
              Download
            </a>
          </div>
        </div>
        </div>
      </div>
    </div>   

       
  );
}
